import Axios from "axios";

function Api() {
  const get = function (route) {
    log.info(1,"🌜 GET: ", route)
    return Axios.get(route);
  };
  const post = function (route, params) {
    log.info(1,"🌜 POST: ", route, params)
    return Axios.post(route, params);
  };
  const put = function (route, params) {
    log.info(1,"🌜 PUT: ", route, params)
    return Axios.put(route, params);
  };
  const destroy = function (route) {
    log.info(1,"🌜 DELETE: ", route)
    return Axios.delete(route);
  };

  return { get, post, put, destroy };
}

export function createApi(args) {
  // args.handler.defaults.baseURL = `/${window.I18n.prefix}api${args.namespace}/`;
  args.handler.defaults.baseURL = `/backend${args.namespace}/`;
  args.handler.defaults.headers.common["X-CSRF-Token"] = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute("content");
  
  const isIframe = window !== window.parent;
  args.handler.defaults.headers.common['X-Frame-Context'] = isIframe ? 'iframe' : 'direct';
  args.handler.defaults.headers.common['X-Frame-Referrer'] = isIframe ? document.referrer : window.location.href;
  args.handler.defaults.headers.common['X-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
  args.handler.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      switch (error.response.status) {
        case 500:
          // window.location.href = "/500";
          console.log(error)
          break;
        case 401:
          console.log("🔴 Unauthorized")
          // let str = '/login'
          // if (window.VITE_DEVELOPMENT) {
          //   str = '/register'
          // }
          // let next = window.location.pathname + window.location.search
          // if (next != '/') {
          //   str += '?return=' + next
          // }
          // window.location.href = str
          // break;
      }

      return Promise.reject(error);
    }
  );

  return new Api();
}
